<script>
import cloneDeep from 'lodash/cloneDeep'
import { ROLE } from '@utils/constant'
import { request } from '@/src/services'
import editFields from './editFields'
import optionLevel from './optionLevel'
export default {
  page: {
    title: 'Admin Edit',
    meta: [{ name: 'description', content: 'The Admin Edit page.' }],
  },
  data: function() {
    return {
      items: cloneDeep(editFields),
      roleRequired: [ROLE.SUPER, ROLE.AGENT_ADMIN],
      admin: {},
      id: this.$route.params.id,
      title: this.$t('pages.editAdmin'),
    }
  },
  computed: {
    editFieldData() {
      const data = this.items?.map((field) => {
        field.value = this.admin[field.key]
        return field
      })
      return data
    },
    confirmComputed() {
      if (this.admin.level === ROLE.SUPER) {
        return 'change_password'
      }
      return 'edit'
    },
  },
  created() {
    this.handleSearchAdmin()
  },
  methods: {
    onEditAdmin() {
      const payload = this.items.reduce((results, item) => {
        results[item.key] = item.value
        return results
      }, {})
      request({
        endpoint: '/cms/admin/edit/',
        payload: {
          ...payload,
          agent_id: this.admin.agent_id,
          id: parseInt(this.id),
        },
      }).then(() => {
        if (this.items[5].value === 0) {
          this.$router.push('/panel/logout')
        } else {
          this.$router.push('/panel/admin-list')
        }
      })
    },
    handleSearchAdmin() {
      request({
        endpoint: '/cms/admin/get/',
        payload: {
          id: parseInt(this.id),
        },
      }).then((res) => {
        this.admin = res

        this.items = this.editFieldData
        this.items[0].options = [
          { value: this.items[0].value, label: this.items[0].value },
        ]
        if (this.items[3].value === undefined) {
          this.items[3].value = ''
        }

        if (this.items[4].value === undefined) {
          this.items[4].value = ''
        }

        if (this.items[5].value === 0) {
          this.items[1].disabled = true
          this.items[2].disabled = true
        }
        this.items[5].disabled = optionLevel[this.items[5].value].disabled
        this.items[5].rules = optionLevel[this.items[5].value].rules
        this.items[5].options = optionLevel[this.items[5].value].options
      })
    },
    goBackPage() {
      this.$router.push('/panel/admin-list')
    },
    isRequiredPassword(key) {
      const field = {
        passwordConfirm: 4,
        password: 3,
      }
      if (this.items[field[key]].value !== '') {
        return true
      }
      return false
    },
    isComfirmedPassword() {
      if (this.items[2].value !== '' && this.items[3].value !== '') {
        return 'password'
      } else {
        return false
      }
    },
  },
}
</script>

<template>
  <div>
    <BaseAddNewCard
      :type="confirmComputed"
      @submit="onEditAdmin"
      @cancel="goBackPage"
    >
      <template v-slot:header>
        <h5 class="card-title">{{ title }}</h5>
      </template>
      <template v-slot>
        <CRow v-for="item in items" :key="item.key">
          <CCol sm="3">
            {{ item.label }}
            <span v-if="item.rules.required" class="text-danger">*</span>
          </CCol>
          <CCol sm="9">
            <BaseSelect
              v-if="item.as === 'select'"
              :value.sync="item.value"
              :rules="item.rules"
              :name="item.name"
              :vee-name="item.name"
              :type="item.type"
              :options="item.options"
              autocomplete="off"
              :disabled="item.disabled"
            >
            </BaseSelect>
            <BaseInput
              v-if="item.as === 'input' && item.key === 'password'"
              v-model="item.value"
              :rules="{
                password: true,
                required:
                  isRequiredPassword('passwordConfirm') &&
                  item.value.length <= 0,
              }"
              :name="item.name"
              :vee-name="item.name"
              :type="item.type"
              autocomplete="new-password"
              :disabled="item.disabled"
            />
            <BaseInput
              v-if="item.as === 'input' && item.key === 'password_2'"
              v-model="item.value"
              :rules="{
                password: true,
                required:
                  isRequiredPassword('password') && item.value.length <= 0,
                confirmed: isComfirmedPassword(),
              }"
              :name="item.name"
              :vee-name="item.name"
              :type="item.type"
              autocomplete="new-password"
              :disabled="item.disabled"
            />
            <BaseInput
              v-if="item.as === 'input' && item.key === 'admin_display_name'"
              v-model="item.value"
              :rules="item.rules"
              :name="item.name"
              :vee-name="item.name"
              :type="item.type"
              autocomplete="new-password"
              :disabled="item.disabled"
            />
            <BaseInput
              v-if="item.as === 'input' && item.key === 'admin_name'"
              v-model="item.value"
              :rules="item.rules"
              :name="item.name"
              :vee-name="item.name"
              :type="item.type"
              autocomplete="new-password"
              :disabled="item.disabled"
            />
            <BaseTextarea
              v-if="item.as === 'area'"
              v-model="item.value"
              :rules="item.rules"
              :name="item.name"
              :vee-name="item.name"
              :type="item.type"
              autocomplete="off"
              :disabled="item.disabled"
            />
          </CCol>
        </CRow>
      </template>
    </BaseAddNewCard>
  </div>
</template>

<style lang="scss" scoped>
.card-title {
  margin-bottom: 0 !important;
  font-weight: 600;
  color: #73818f;
}
</style>
